import type { ReactNode } from 'react';
import { useAuth } from '../lib/auth';
import { useMember } from '../lib/members';

interface Props {
  children: ReactNode;
}

export default function MemberGate({ children }: Props) {
  const { user } = useAuth();
  const { member, loading, error } = useMember(user?.uid ?? null);
  if (!user) return null;
  if (loading) return <p className="p-4 text-center">Laddar medlemsdata…</p>;
  if (error) {
    return (
      <div className="max-w-md mx-auto mt-16 bg-white rounded-lg shadow p-6">
        <h1 className="text-xl font-bold mb-2 text-navy">
          Kunde inte ladda medlemsdata
        </h1>
        <p className="text-sm">
          Försök igen om en stund eller kontakta styrelsen.
        </p>
      </div>
    );
  }
  if (!member) {
    return (
      <div className="max-w-md mx-auto mt-16 bg-white rounded-lg shadow p-6">
        <h1 className="text-xl font-bold mb-2 text-navy">Du är inte medlem</h1>
        <p className="text-sm">
          Vi hittar inget medlemskonto kopplat till din e-post. Kontakta
          styrelsen.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
